<template>
    <div class="codics-book-body">
        <el-form
            style="height: fit-content;width: 470px;position: absolute;margin: auto;top: -140px;left: -400px;right: 0;bottom: 0;">
            <el-form-item label="画册尺寸" :label-width="'300px'">
                <div>{{ (pdfSize / 1024 / 1024).toFixed(2) }}MB</div>
            </el-form-item>
            <el-form-item label="每张尺寸" :label-width="'300px'">
                <div>{{ (pdfSize / 1024 / totalPages).toFixed(2) }}KB</div>
            </el-form-item>
            <el-form-item label="画册链接" :label-width="'300px'">
                <div v-html="showTxt"></div>
            </el-form-item>
            <el-form-item label="画面尺寸(越高越清晰)" :label-width="'300px'">
                <el-input-number v-model="scaleNum" :min="1" :max="5" label="画面清晰度"></el-input-number>
            </el-form-item>
            <el-form-item label="压缩等级(越高越清晰)" :label-width="'300px'">
                <el-slider v-model="hmNum" :min="10" :max="100"></el-slider>
            </el-form-item>
            <el-form-item label="画册上传" :label-width="'300px'">
                <el-upload class="codics-book-upload" :http-request="uploadFile" :show-file-list="false" drag
                    action="files.kylebing.cn" accept=".pdf">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将pdf文件拖到此处，或<em>点击上传</em></div>
                </el-upload>
            </el-form-item>
        </el-form>
        <!-- <div class="codics-book-upload-title">PDF转画册</div> -->

        <!-- 添加表单 -->
        <el-dialog title="添加画册" :close-on-click-modal='false' :visible.sync="bookVisible" width="80%">
            <el-form :model="addForm">
                <el-form-item label="画册名称" :label-width="formLabelWidth">
                    <el-input v-model="addForm.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="画册介绍（微信分享使用）" :label-width="formLabelWidth">
                    <el-input v-model="addForm.desc" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="画册封面（微信分享使用）" :label-width="formLabelWidth">
                    <el-upload class="codics-firm-book-upload-dialog-himg-uploador" action="cdn.bosscaigou.com"
                        list-type="picture-card" multiple :http-request="uploadFile2"
                        :style="{ '--dataSize': addForm.himg == '' ? 'inline-block' : 'none' }">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="bookVisible = false">取 消</el-button>
                <el-button type="primary" @click="addPdfFuc();">确 定</el-button>
            </div>
        </el-dialog>
        <!-- <label id="pickFile" class="codics-book-upload">
            <input type="file" id="fileInput1" name="file" style="visibility: hidden;" accept="application/pdf"
                @change="uploadFile">
            <i class="iconfont codics-book-upload-icon">&#xe679;</i>
        </label> -->
        <!-- <div id="imgShow" class="codics-book-upload-img-box">

        </div> -->
        <!-- <input class="codics-book-upload" id="chooseFile" type="file" > -->
        <!-- <ul class="codics-book-upload-list" v-infinite-scroll="load" style="overflow:auto">
            <li v-for="(item, index) in fileList" :key="index" class="infinite-list-item codics-book-upload-list-item">
                {{
            '/file/电子画册/' + index + '.pdf' }}</li>
        </ul> -->

        <MyLoading v-show="uploadState" :show-txt="'文件上传进度' + uploadProgress + '%，请耐心等待...'"></MyLoading>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { getQiNiuToken, userInfos, addPdf } from '@/api';
import { randomString, jumpTo, base64ToFile } from '@/utils/myutils';
import * as qiniu from 'qiniu-js';
import MyLoading from '@/components/MyLoading';
export default {
    data() {
        return {
            pdfSize: 0,
            hmNum: 92,
            bookVisible: false,
            formLabelWidth: '120px',
            addForm: {
                name: '',
                desc: '',
                himg: ''
            },
            qiNiuInfo: {
                token: null
            },
            uploadState: false,
            showTxt: '生成的链接在这里展示...',
            totalPages: 0,
            uploadProgress: 0,
            scaleNum: 2,//设置缩放比例，越大生成图片越清晰
            fileList: ['', '', ''],
            imgList: [],
            nowPages: 0
        }
    },
    mounted() {
        import('@/../public/js/pdf.mjs');
        import('@/../public/js/pdf.worker.mjs');
        import('@/../public/js/FileSaver.js');
        import('@/../public/js/jszip.min.js');
        this.getTokenFuc();
    },
    methods: {
        load() {
            this.count += 2
        },
        async getTokenFuc() {
            let data = await getQiNiuToken();
            if (data.code == 200) {
                this.qiNiuInfo.token = data.uptoken;
            } else {
                this.$message.error(data.message);
            }
        },
        renderImg(_this, pdfFile, pageNumber, canvasContext, canvas) {

            // console.log(pdfFile)

            pdfFile.getPage(pageNumber).then(function (page) { //逐页解析PDF

                console.log(page)

                var newcanvas = canvasContext.canvas;

                var viewport = page.getViewport({ scale: _this.scaleNum || 1 }); // 页面缩放比例
                //设置canvas真实宽高
                newcanvas.width = viewport.width;//page._pageInfo.view[2]

                newcanvas.height = viewport.height;//page._pageInfo.view[3]

                canvasContext.translate(newcanvas.width / 2, newcanvas.height / 2);

                canvasContext.translate(-newcanvas.width / 2, -newcanvas.height / 2);

                newcanvas.style.width = "100%";

                newcanvas.style.height = "100%";

                var renderContext = {
                    canvasContext: canvasContext,
                    viewport: viewport
                };

                page.render(renderContext).promise.then(function () {

                    canvasContext.translate(newcanvas.width / 2, newcanvas.height / 2);

                    canvasContext.translate(-newcanvas.width / 2, -newcanvas.height / 2);

                    const a = base64ToFile(canvas.toDataURL("image/webp", Number.parseFloat((_this.hmNum / 100).toFixed(1))), 'image.webp', 'image.webp');

                    _this.pdfSize += a.size;

                    let pdfPath = 'huayuan/img/' + randomString(10) + '_' + new Date().getTime() + '_' + _this.userInfo.user.id + '.webp';
                    // 上传文件
                    const observer = {
                        next(res) {

                            _this.uploadProgress = res.total.percent.toFixed(2 / _this.totalPages);

                        },
                        error(err) {
                            _this.uploadState = false;
                        },
                        complete(res) {

                            _this.imgList[pageNumber - 1] = res.key;

                            _this.nowPages++;

                            if (_this.nowPages === _this.totalPages) {

                                _this.bookVisible = true;

                                _this.uploadState = false;

                            }

                            // _that.addPdfFuc(, , '')
                        }
                    }

                    const observable = qiniu.upload(a, pdfPath, _this.qiNiuInfo.token, {

                        params: { 'x:name': 'qiniu' },

                    }, {
                        region: qiniu.region.z0
                    })
                    const subscription = observable.subscribe(observer) // 上传开始

                });
            });
            return;
        },
        uploadFile(uploadInfo) {

            this.pdfSize = 0;

            const _this = this;

            this.totalPages = 0;

            this.nowPages = 0;

            _this.uploadState = true;

            _this.imgList = [];

            var reader = new FileReader();

            reader.readAsDataURL(uploadInfo.file); //将文件读取为 DataURL

            reader.onload = function (e) { //文件读取成功完成时触发

                _this.loadProgress = 30;

                pdfjsLib.getDocument(reader.result).promise.then(function (pdf) {

                    if (pdf) {

                        _this.totalPages = pdf.numPages;

                        for (var i = 1; i <= _this.totalPages; i++) {

                            var canvas = document.createElement('canvas');

                            canvas.id = "pageNum" + i;

                            var context = canvas.getContext('2d');

                            _this.renderImg(_this, pdf, i, context, canvas);

                        }

                    }

                });

            };








            // this.uploadState = true;
            // //请先登录平台
            // if (!this.userInfo) {

            //     this.$message({
            //         showClose: true,
            //         message: '请先完成登录后再进行操作！',
            //         type: 'warning'
            //     });

            //     this.$store.dispatch('logout')

            //     jumpTo(this, "登录", {}, {});

            //     return;

            // }

            // if (this.qiNiuInfo.token == null) {
            //     //请先获取上传Token
            //     this.$message({
            //         showClose: true,
            //         message: '请刷新网站以重新获取Token！',
            //         type: 'warning'
            //     });

            //     return;
            // }

            // let pdfPath = 'huayuan/pdf/' + randomString(10) + '_' + new Date().getTime() + '_' + this.userInfo.user.id + '.pdf';

            // const _that = this;
            // // 上传文件
            // const observer = {
            //     next(res) {
            //         // console.log('next: ', res)
            //         _that.uploadProgress = res.total.percent.toFixed(2);;
            //     },
            //     error(err) {
            //         // console.log(err)
            //         _that.uploadState = false;
            //     },
            //     complete(res) {
            //         // console.log('complete: ', res)

            //         _that.addForm.name = uploadInfo.file.name.split('.')[0];
            //         _that.addForm.url = res.key;
            //         _that.bookVisible = true;
            //         _that.showTxt = res.key;
            //         _that.uploadState = false;

            //         // _that.addPdfFuc(, , '')
            //     }
            // }
            // // console.log(uploadInfo.file);
            // const observable = qiniu.upload(uploadInfo.file, pdfPath, this.qiNiuInfo.token, {
            //     params: { 'x:name': 'qiniu' },
            // }, {
            //     region: qiniu.region.z0
            // })
            // const subscription = observable.subscribe(observer) // 上传开始



            // --------------------------------
            // console.log(subscription);
            // subscription.unsubscribe() // 上传取消
        },
        // uploadFile(e) {
        //     var _this = this;
        //     console.log(e);
        //     // var pdfPath = e.target.value;
        //     var fileData = e.file;
        //     var fileSize = fileData.size;
        //     var mb;
        //     if (fileSize) {// 限制上传文件尺寸
        //         mb = fileSize / 1048576;
        //         // if(mb > 10) {
        //         //   alert("文件大小不能>10M");
        //         //   return;
        //         // }
        //     }
        //     var reader = new FileReader();
        //     reader.readAsDataURL(fileData); //将文件读取为 DataURL
        //     reader.onload = function (e) { //文件读取成功完成时触发
        //         console.log(pdfjsLib);
        //         pdfjsLib.getDocument(reader.result).promise.then(function (pdf) { //调用pdf.js获取文件
        //             if (pdf) {
        //                 _this.totalPages = pdf.numPages; //获取pdf文件总页数
        //                 // $("#currentPages").text("1/");
        //                 // $("#totalPages").text(totalPages);
        //                 var imgShow = document.getElementById("imgShow");
        //                 //遍历动态创建canvas
        //                 for (var i = 1; i <= _this.totalPages; i++) {
        //                     var canvas = document.createElement('canvas');
        //                     canvas.id = "pageNum" + i;
        //                     // imgShow.appendChild(canvas);
        //                     var context = canvas.getContext('2d');
        //                     _this.renderImg(pdf, i, context, canvas);
        //                 }
        //             }
        //         });
        //     };
        // },
        // renderImg(pdfFile, pageNumber, canvasContext, canvas) {
        //     var _this = this;
        //     pdfFile.getPage(pageNumber).then(function (page) { //逐页解析PDF
        //         var viewport = page.getViewport(_this.scaleNum); // 页面缩放比例
        //         var newcanvas = canvasContext.canvas;
        //         //设置canvas真实宽高
        //         newcanvas.width = viewport.width;
        //         newcanvas.height = viewport.height;
        //         //设置canvas在浏览中宽高
        //         newcanvas.style.width = "100%";
        //         newcanvas.style.height = "100%";
        //         //默认显示第一页，其他页隐藏
        //         if (pageNumber != 1) {
        //             newcanvas.style.display = "none";
        //         }
        //         var renderContext = {
        //             canvasContext: canvasContext,
        //             viewport: viewport
        //         };
        //         page.render(renderContext).promise.then(function () {
        //             console.log(canvas.toDataURL("image/png", 1.0))
        //         });; //渲染生成
        //     });
        //     // $("#imgloading").css('display', 'none');
        //     return;
        // },
        // 上传方法
        uploadFile2(uploadInfo) {

            let imgPath = 'huayuan/img/' + randomString(10) + '_' + new Date().getTime() + '_' + this.userInfo?.user?.id + '.png';

            const _that = this;
            // 上传文件
            const observer2 = {
                next(res) {
                    // console.log('next: ', res)
                },
                error(err) {
                    // console.log(err)
                },
                complete(res) {
                    // console.log('complete: ', res)
                    _that.addForm.himg = res.key;

                }
            }
            // console.log(uploadInfo.file);
            const observable2 = qiniu.upload(uploadInfo.file, imgPath, this.qiNiuInfo.token, {}, {
            })
            const subscription2 = observable2.subscribe(observer2) // 上传开始
            // console.log(subscription);
            // subscription2.unsubscribe() // 上传取消
        },

        async addPdfFuc() {
            if (this.addForm.name == '' || this.addForm.desc == '') {

                //请先获取上传Token
                this.$message({
                    showClose: true,
                    message: '画册的名称以及画册介绍不能为空！',
                    type: 'warning'
                });

                return;

            }

            this.addForm.url = this.imgList.join(",");

            if (this.addForm.himg == '') {
                //请先获取上传Token
                this.$message({
                    showClose: true,
                    message: '请先上传画册封面！',
                    type: 'warning'
                });

                return;

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await addPdf(this.addForm);

            loading.close();

            if (data.code == 200) {
                this.showTxt = "<a href='" + window.location.origin + "/book/show/" + data.data.id + "' target='_blank'>" + window.location.origin + "/book/show/" + data.data.id + "</a>";
            } else {
                this.$message.error(data.message);
            }
            this.bookVisible = false;
        }
    },
    components: {
        MyLoading
    },
    computed: {
        ...mapState(['userInfo'])
    },
}
</script>

<style>
.codics-book-body {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    background: #FFF;
}

.codics-book-upload-title {
    height: 50px;
    width: fit-content;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 55%;
    line-height: 50px;
    text-align: center;
    font-size: 35px;
    color: #333;
}

.codics-book-upload {
    height: fit-content;
    width: fit-content;
    position: absolute;
    margin: unset !important;
    /* left: 0; */
    /* right: 0; */
    /* top: 0; */
    /* bottom: 0; */
    /* border: dashed 1px #333; */
    cursor: pointer;
}

.codics-book-upload-progress {
    height: 20px;
    width: 90%;
    max-width: 800px;
    position: absolute !important;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.codics-book-upload-icon {
    height: 50px;
    width: 50px;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    line-height: 50px;
    text-align: center;
    font-size: 30px;
    user-select: none;
    cursor: pointer;
}

.codics-book-upload-list {
    height: calc(100% - 120px);
    width: 100%;
    max-width: 300px;
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}

.codics-book-upload-list-item {
    height: 50px;
    width: 100%;
    line-height: 50px;
    padding-left: 15px;
    color: #333;
    background: #E8F3FE;
    font-size: 14px;
    color: #333;
    user-select: none;
    cursor: pointer;
    margin-bottom: 5px;
}

.codics-book-upload-url {
    height: 40px;
    width: 80%;
    max-width: 980px;
    position: absolute;
    margin: auto;
    line-height: 40px;
    text-align: center;
    left: 0;
    right: 0;
    top: 0;
    bottom: -55%;
    border: dashed 1px #d9d9d9;
    font-size: 13px;
    color: #333;
    cursor: pointer;
}

.codics-book-upload-url:hover {
    border-color: #409EFF;
}

.codics-book-upload-img-box {
    height: 300px;
    width: 300px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

@media (max-width:768px) {
    .codics-book-upload-list {
        display: none;
    }
}

.codics-firm-book-upload-dialog-himg-uploador .el-upload {
    display: var(--dataSize);
}

.codics-book-upload-num-pick {
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
}
</style>